<template>
  <div class="brand-form-wrapper">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :disabled="status === 1"
      label-width="180px"
      inline-message
      class="brand-form"
      size="mini"
    >
      <!-- 品牌名称 -->
      <el-form-item inline-message label="品牌名称：" required>
        <el-row
          type="flex"
          :gutter="24"
          justify="space-between"
          style="height: 28px;"
        >
          <el-col :span="20">
            <el-form-item prop="brandName">
              <el-input
                ref="brandName"
                v-model="ruleForm.brandName"
                :disabled="status === 1 || formEdit"
                @input="_limitLen(undefined, undefined, key = 'brandName', len = 20)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :offset="1" :span="3">
            <el-button class="mi-primary" :disabled="status === 1" @click="showFormDialog">添加品牌</el-button>
          </el-col>
        </el-row>
        <div v-show="reasons.brandNameReview" class="reason block">驳回原因：{{ reasons.brandNameReview }}</div>
      </el-form-item>

      <!-- 品牌英文名称 -->
      <el-form-item label="品牌英文名称：" prop="brandEnglishName">
        <el-input v-model="ruleForm.brandEnglishName" :disabled="formEdit" @input="_limitLen(undefined, undefined, key = 'brandEnglishName', len = 20)"></el-input>
        <div v-show="reasons.brandEnglishNameReview" class="reason">驳回原因：{{ reasons.brandEnglishNameReview }}</div>
      </el-form-item>
      <el-form-item label="品牌logo：" prop="brandLogo">
        <span class="download-tips">必须与商标图文一致，图片尺寸<span class="highlight">800px*800px</span>，大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>。</span>
        <el-upload
          v-model="ruleForm.brandLogo"
          :disabled="status === 1 || formEdit"
          class="avatar-uploader"
          :class="[ruleForm.brandLogo ? 'active' : 'inactive']"
          action=""
          accept="image/*"
          :show-file-list="false"
          :http-request="ctx => imageUpload(ctx, 'ruleForm', 'ruleForm','brandLogo')"
          :before-upload="beforeImageUpload(1,800,800,false)"
        >
          <div v-if="status !== 1 && !formEdit && ruleForm.brandLogo" class="btn-close" @click.stop="removeImage(ruleForm, 'brandLogo')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.brandLogo" :src="encodeImgURl('ruleForm', 'brandLogo')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.brandEnglishNameReview" class="reason uploader-reason" style="margin-top: 27px">驳回原因：{{ reasons.brandEnglishNameReview }}</div>
      </el-form-item>

      <!-- 品牌slogan -->
      <el-form-item label="品牌slogan：" prop="brandSlogan">
        <el-input v-model="ruleForm.brandSlogan" :disabled="status === 1 || formEdit" @input="_limitLen(undefined, undefined, key = 'brandSlogan', len = 20)"></el-input>
        <div v-show="reasons.brandSloganReview" class="reason">驳回原因：{{ reasons.brandSloganReview }}</div>
      </el-form-item>

      <!-- 品牌介绍 -->
      <el-form-item label="品牌介绍：" prop="brandIntroduction">
        <el-input
          v-model="ruleForm.brandIntroduction"
          type="textarea"
          :disabled="status === 1 || formEdit"
          @input="_limitLen(undefined, undefined, key = 'brandIntroduction', len = 300)"
        ></el-input>
        <div v-show="reasons.brandIntroductionReview" class="reason">驳回原因：{{ reasons.brandIntroductionReview }}</div>
      </el-form-item>

      <!-- 品牌类型 -->
      <el-form-item label="品牌类型：" prop="brandType">
        <el-radio-group v-model="ruleForm.brandType" :disabled="status === 1">
          <el-radio label="1">国内品牌</el-radio>
          <el-radio label="2">国际品牌</el-radio>
        </el-radio-group>
        <div v-show="reasons.brandTypeReview" class="reason">驳回原因：{{ reasons.brandTypeReview }}</div>
      </el-form-item>

      <div class="header">
        <div class="title">代理信息</div>
      </div>

      <!-- 经营类型 -->
      <el-form-item label="经营类型：" prop="managementType">
        <el-radio-group v-model="ruleForm.managementType" :disabled="status === 1" @change="managementTypeChange">
          <el-radio label="1">自有品牌</el-radio>
          <el-radio label="2">代理品牌</el-radio>
        </el-radio-group>
        <div v-show="reasons.managementTypeReview" class="reason">驳回原因：{{ reasons.managementTypeReview }}</div>
      </el-form-item>

      <!-- 代理等级 -->
      <div v-if="ruleForm.managementType === '2'">
        <el-form-item label="代理等级：" required>
          <el-select
            v-model="ruleForm.proxyLevel"
            placeholder="请选择"
            :disabled="status === 1"
            @change="proxyLevelChange(ruleForm.proxyLevel)"
          >
            <el-option
              v-for="item in agentOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <div v-show="reasons.proxyLevelReview" class="reason">驳回原因：{{ reasons.proxyLevelReview }}</div>
        </el-form-item>

        <!-- 代理授权书 -->
        <el-form-item
          v-for="(item, index) in ruleForm.proxyInfos"
          :key="index"
          :label="agentOptions[index].name + '授权书：'"
          required
        >
          <el-form-item
            label
            :prop="`proxyInfos[${index}].objectId`"
            :rules="rules.proxyInfosObjectId"
            :inline-message="false"
          >
            <div>
              <span class="download-tips">请上传{{ agentOptions[index].name }}品牌授权书&nbsp;&nbsp;</span>
              <a class="download-text" href="javascript:void(0)" @click="downloadFile('/file/brand.docx', '品牌授权书.docx')">(点击查看详细说明&下载授权书模板)</a>
            </div>
            <el-upload
              v-model="proxyTmpImg"
              class="multiple-uploader"
              :class="[item.objectId ? 'active' : 'inactive']"
              action=""
              accept="image/*"
              :disabled="status === 1"
              :show-file-list="false"
              :http-request="ctx => proxyImageUpload(ctx, index)"
              :before-upload="beforeImageUpload()"
            >
              <div class="flex-box">
                <div v-if="item.objectId" class="items">
                  <div v-for="(id, idx) in item.objectId" :key="id" class="img-item">
                    <div v-if="status !== 1" class="btn-close" @click.stop="removeProxyImage(item.objectId, idx)">
                      <img src="@/assets/img/icon-close.png">
                    </div>
                    <img :src="encodeImgURl(id)" class="avatar" @click.stop>
                  </div>
                </div>
                <div v-if="status !== 1 && (!item.objectId || item.objectId.length < 5)" class="upload-box">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </div>
            </el-upload>
          </el-form-item>

          <!-- 授权书有效期 -->
          <el-form-item>
            <span class="download-tips">图片尺寸<span class="highlight">800px * 800px</span>以上，图片大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>，请保证授权书信息清晰可见。</span>
          </el-form-item>
          <el-form-item label="授权书有效期：" label-width="110" required>
            <el-col :span="6">
              <el-form-item :prop="`proxyInfos[${index}].startDate`" :rules="rules.proxyInfosStartDate">
                <el-date-picker
                  v-model="item.startDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :disabled="status === 1"
                  :picker-options="{disabledDate(time) {
                    return time.getTime() > Date.now()
                  }}"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="1" style="textAlign: center">-</el-col>
            <el-col :span="6">
              <el-form-item :prop="`proxyInfos[${index}].endDate`" :rules="rules.proxyInfosEndDate(index)">
                <el-date-picker
                  v-model="item.endDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :disabled="status === 1"
                  :picker-options="{disabledDate(time) {
                    return time.getTime() < Date.now()
                  }}"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form-item>
      </div>

      <div class="header">
        <div class="title">商标信息</div>
      </div>

      <!-- 商标资质类型 -->
      <el-form-item label="商标资质类型：" prop="trademarkQualificationType">
        <el-select v-model="ruleForm.trademarkQualificationType" :disabled="status === 1" placeholder="请选择">
          <el-option
            v-for="item in trademarkQualificationTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <div v-show="reasons.trademarkQualificationTypeReview" class="reason">驳回原因：{{ reasons.trademarkQualificationTypeReview }}</div>
      </el-form-item>

      <!-- 商标证 / 商标受理授权书 -->
      <el-form-item :label="ruleForm.trademarkQualificationType === 1 ? '商标证：' : '商标受理通知书：'" prop="trademarkQualificationObjectId">
        <span class="download-tips">必须与商标图文一致，图片尺寸<span class="highlight">800px*800px</span>，大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>。</span>
        <el-upload
          v-model="ruleForm.trademarkQualificationObjectId"
          class="avatar-uploader"
          :class="[ruleForm.trademarkQualificationObjectId ? 'active' : 'inactive']"
          action=""
          accept="image/*"
          :disabled="status === 1"
          :show-file-list="false"
          :http-request="ctx => imageUpload(ctx, 'ruleForm', 'ruleForm','trademarkQualificationObjectId')"
          :before-upload="beforeImageUpload()"
        >
          <div v-if="status !== 1 && ruleForm.trademarkQualificationObjectId" class="btn-close" @click.stop="removeImage(ruleForm, 'trademarkQualificationObjectId')">
            <img src="@/assets/img/icon-close.png">
          </div>
          <img v-if="ruleForm.trademarkQualificationObjectId" :src="encodeImgURl('ruleForm', 'trademarkQualificationObjectId')" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div v-show="reasons.trademarkQualificationObjectIdReview" class="reason uploader-reason">驳回原因：{{ reasons.trademarkQualificationObjectIdReview }}</div>
      </el-form-item>

      <!-- 商标注册人 / 商标申请人 -->
      <el-form-item :label="ruleForm.trademarkQualificationType === 1 ? '商标注册人：' : '商标申请人：'" prop="trademarkQualificationRegistrant">
        <el-input v-model="ruleForm.trademarkQualificationRegistrant" :disabled="status === 1" @input="_limitLen(undefined, undefined, key = 'trademarkQualificationRegistrant', len = ruleForm.trademarkQualificationType === 1 ? 20 : 30)"></el-input>
        <div v-show="reasons.trademarkQualificationRegistrantReview" class="reason">驳回原因：{{ reasons.trademarkQualificationRegistrantReview }}</div>
      </el-form-item>

      <!-- 商标类别 -->
      <el-form-item label="商标类别：" prop="trademarkQualificationCategory">
        <el-input v-model="ruleForm.trademarkQualificationCategory" :disabled="status === 1" @input="_limitLen(undefined, undefined, key = 'trademarkQualificationCategory', len = 20)"></el-input>
        <div v-show="reasons.trademarkQualificationCategoryReview" class="reason">驳回原因：{{ reasons.trademarkQualificationCategoryReview }}</div>
      </el-form-item>

      <!-- 商标号 / 申请号 -->
      <el-form-item :label="ruleForm.trademarkQualificationType === 1 ? '商标号：' : '申请号：'" prop="trademarkQualificationNumber">
        <el-input v-model="ruleForm.trademarkQualificationNumber" :disabled="status === 1" @input="_limitLen(undefined, undefined, key = 'trademarkQualificationNumber', len = 20)"></el-input>
        <div v-show="reasons.trademarkQualificationNumberReview" class="reason">驳回原因：{{ reasons.trademarkQualificationNumberReview }}</div>
      </el-form-item>

      <!-- 商标到期日 / 受理通知书有效期 -->
      <el-form-item
        :label="ruleForm.trademarkQualificationType === 1 ? '商标到期日：' : '受理通知书有效期：'"
        :required="ruleForm.trademarkQualificationType === 1"
        class="date"
      >
        <el-col :span="6">
          <el-form-item prop="trademarkQualificationStartDate" :rules="rules.trademarkQualificationStartDate">
            <el-date-picker
              v-model="ruleForm.trademarkQualificationStartDate"
              :disabled="status === 1 || ruleForm.trademarkQualificationLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="{disabledDate(time) {return time.getTime() > Date.now()}}"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="1" style="textAlign: center">-</el-col>
        <el-col :span="6">
          <el-form-item prop="trademarkQualificationEndDate" :rules="rules.trademarkQualificationEndDate">
            <el-date-picker
              v-model="ruleForm.trademarkQualificationEndDate"
              :disabled="status === 1 || ruleForm.trademarkQualificationLongTermEffective"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="{disabledDate(time) {return time.getTime() < Date.now()}}"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="3" style="marginLeft: 10px">
          <el-checkbox v-model="ruleForm.trademarkQualificationLongTermEffective" :disabled="status === 1">长期有效</el-checkbox>
        </el-col>
        <div v-show="reasons.trademarkQualificationPeriodReview" class="reason">驳回原因：{{ reasons.trademarkQualificationPeriodReview }}</div>
      </el-form-item>

      <div class="header">
        <div class="title">销售信息</div>
      </div>

      <!-- 第三方平台售卖证明 -->
      <el-form-item label="第三方平台售卖证明：" prop="invitationCode">
        <el-button
          class="mi-primary"
          icon="el-icon-plus"
          :disabled="status === 1"
          @click="addProof"
        >
          添加第三方售卖证明
        </el-button>
      </el-form-item>
      <el-form-item class="proof-item">
        <el-table
          :data="ruleForm.thirdPartyPlatformInfos"
          style="width: 602px"
          max-height="200"
          size="mini"
          class="table-proof"
          border
        >
          <el-table-column
            prop="salesChannel"
            label="第三方售卖渠道"
            width="260"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`thirdPartyPlatformInfos[${scope.$index}].salesChannel`"
                :rules="rules.proofName"
                :inline-message="false"
                :class="{'auto-height': true}"
              >
                <el-input v-model="scope.row.salesChannel" :disabled="status === 1"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="第三方平台店铺链接" width="260">
            <template slot-scope="scope">
              <el-form-item
                :prop="`thirdPartyPlatformInfos[${scope.$index}].storeLink`"
                :rules="rules.thirdPartyUrl"
                :inline-message="false"
                :class="{'auto-height': true}"
              >
                <el-input v-model="scope.row.storeLink" :disabled="status === 1"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="brandLogo" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="btn-warning"
                icon="el-icon-delete"
                circle
                :disabled="status === 1"
                @click="removeProof(scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-show="reasons.thirdPartyPlatformInfosReview" class="reason block">驳回原因：{{ reasons.thirdPartyPlatformInfosReview }}</div>
      </el-form-item>

      <!-- 品牌年总销售额 -->
      <el-form-item label="品牌年总销售额：" prop="brandAnnualTotalConsumption">
        <el-input v-model="ruleForm.brandAnnualTotalConsumption" :disabled="status === 1" style="width: 140px"></el-input>
        <span>&nbsp;万</span>
        <div v-show="reasons.brandAnnualTotalConsumptionReview" class="reason">驳回原因：{{ reasons.brandAnnualTotalConsumptionReview }}</div>
      </el-form-item>

      <!-- 表单提交 -->
      <el-form-item class="form-footer">
        <el-button v-if="status === 0" class="mi-primary-plain" @click="lastAllStep()">上一步</el-button>
        <el-button
          v-if="status === 0"
          class="mi-primary"
          :disabled="saveBtnDisabled"
          @click="submitForm('ruleForm')"
        >
          保存并提交
        </el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择品牌"
      width="620px"
      :visible="showBrandsTable"
      @close="closeFormDialog"
    >
      <el-form
        ref="tableForm"
        :model="tableForm"
        :rules="tableRules"
        label-width="85px"
        size="mini"
        inline-message
        @submit.native.prevent
      >
        <el-row :gutter="24" type="flex" justify="space-between">
          <el-col :span="19">
            <el-form-item label="品牌名称：" inline-message prop="keyword">
              <el-input
                v-model="tableForm.keyword"
                v-focus
                placeholder="输入品牌名称"
                @input="_limitLen('tableForm', 'tableForm', 'keyword', 20)"
                @keyup.enter.native.prevent="searchBrand"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" style="textAlign: right">
            <el-button size="mini" @click="searchBrand">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        v-loading="brandListLoading"
        :data="brandList"
        style="width: 100%"
        max-height="400"
        size="mini"
      >
        <el-table-column prop="brandId" label="品牌ID" width="185"></el-table-column>
        <el-table-column prop="brandName" label="品牌名称"></el-table-column>
        <el-table-column prop="brandLogo" label="品牌LOGO" width="100">
          <template slot-scope="scope">
            <img
              v-if="scope.row.brandLogo"
              style="width: 40px"
              :src="'/api/zhaoshang/file/get?objectId='+scope.row.brandLogo"
              class="avatar"
            >
            <i v-else class="el-icon-plus el-icon-picture"></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="brandLogo"
          label="操作"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              style="padding: 7px 10px"
              @click="chooseBrand(scope.row)"
            >
              选择品牌
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div class="row-footer">
          <div class="text">
            <span>未查询到品牌信息，请</span>
            <el-button type="text" @click="addBrand">请添加品牌</el-button>
          </div>
          <div>
            <el-pagination
              small
              background
              layout=" total, prev, pager, next, jumper"
              :current-page.sync="currentPage"
              :pager-count="paginations.pageCount"
              :page-size="paginations.pageSize"
              :total="paginations.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { getCategory, getBrand, postBrand } from '@/api/merchant'
import { processMixin } from '@/common/mixin'
import { deepCopy } from '@/utils'
import { upload } from '@mi/upload'
import brandRules from './rules/brand'

export default {
  mixins: [processMixin],

  props: {
    // 表单状态，0:填写阶段 1:禁止修改 2:可以修改
    status: {
      type: Number,
      default: 0
    }
  },

  data() {
    const rules = {
      brandName: brandRules.brandName(),
      brandEnglishName: brandRules.brandEnglishName(),
      brandLogo: brandRules.brandLogo(),
      brandSlogan: brandRules.brandSlogan(),
      brandIntroduction: brandRules.brandIntroduction(),
      brandType: brandRules.brandType(),
      managementType: brandRules.managementType(),
      proxyInfosObjectId: brandRules.proxyInfosObjectId(),
      proxyInfosStartDate: brandRules.proxyInfosStartDate(),
      proxyInfosEndDate: (index) => brandRules.proxyInfosEndDate(this.getProxyInfosStartDate, index),
      trademarkQualificationType: brandRules.trademarkQualificationType(),
      trademarkQualificationObjectId: brandRules.trademarkQualificationObjectId(this.getTrademarkQualificationType),
      trademarkQualificationRegistrant: brandRules.trademarkQualificationRegistrant(this.getTrademarkQualificationType),
      trademarkQualificationCategory: brandRules.trademarkQualificationCategory(),
      trademarkQualificationNumber: brandRules.trademarkQualificationNumber(this.getTrademarkQualificationType),
      trademarkQualificationStartDate: brandRules.trademarkQualificationStartDate(this.getTrademarkQualificationLongTermEffective, this.getTrademarkQualificationType),
      trademarkQualificationEndDate: brandRules.trademarkQualificationEndDate(this.getTrademarkQualificationLongTermEffective, this.getTrademarkQualificationType),
      proofName: brandRules.proofName(),
      thirdPartyUrl: brandRules.thirdPartyUrl()
    }

    return {
      rules,
      proxyTmpImg: null,
      saveBtnDisabled: false,
      formEdit: true,
      showBrandsTable: false,
      isShowTree: false,
      tableForm: {
        keyword: ''
      },
      // keyword: '',
      paginations: {
        total: 0,
        pageSize: 5,
        pageCount: 5
      },
      currentPage: 1,
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'subCategories'
      },
      ruleForm: {
        /* ---------- 基础信息 ---------- */
        brandId: '',
        brandName: '',
        brandEnglishName: '',
        brandLogo: '',
        brandSlogan: '',
        brandIntroduction: '',
        brandType: '',
        /* ---------- 代理信息 ---------- */
        managementType: '',
        proxyLevel: '1',
        proxyInfosTotal: [
          { level: '1', objectId: '', startDate: '', endDate: '' },
          { level: '2', objectId: '', startDate: '', endDate: '' },
          { level: '3', objectId: '', startDate: '', endDate: '' },
          { level: '4', objectId: '', startDate: '', endDate: '' },
          { level: '5', objectId: '', startDate: '', endDate: '' }
        ],
        proxyInfos: [
          { level: '1', objectId: '', startDate: '', endDate: '' }
        ],
        /* ---------- 商标信息 ---------- */
        trademarkQualificationType: 1,
        trademarkQualificationObjectId: '',
        trademarkQualificationRegistrant: '',
        trademarkQualificationCategory: '',
        trademarkQualificationNumber: '',
        trademarkQualificationStartDate: '',
        trademarkQualificationEndDate: '',
        trademarkQualificationLongTermEffective: false,
        /* ---------- 销售信息 ---------- */
        thirdPartyPlatformInfos: [],
        brandAnnualTotalConsumption: ''
      },
      tableRules: {
        keyword: [
          { min: 0, max: 20, message: '限制输入20个字符', trigger: ['blur'] }
        ]
      },
      reasons: {
        brandNameReview: null,
        brandEnglishNameReview: null,
        brandLogoReview: null,
        brandSloganReview: null,
        brandIntroductionReview: null,
        brandTypeReview: null,
        managementTypeReview: null,
        proxyLevelReview: null,
        trademarkQualificationTypeReview: null,
        trademarkQualificationObjectIdReview: null,
        trademarkQualificationRegistrantReview: null,
        trademarkQualificationCategoryReview: null,
        trademarkQualificationNumberReview: null,
        trademarkQualificationPeriodReview: null,
        brandAnnualTotalConsumptionReview: null,
        thirdPartyPlatformInfosReview: null
      },
      agentOptions: [
        { value: '1', name: '一级代理' },
        { value: '2', name: '二级代理' },
        { value: '3', name: '三级代理' },
        { value: '4', name: '四级代理' },
        { value: '5', name: '五级代理' }
      ],
      trademarkQualificationTypes: [
        { value: 1, name: '商标注册证' },
        { value: 2, name: '商标受理通知书' }
      ],
      categories: [],
      brandListLoading: false,
      brandList: [],
      treeOne: [],
      treeTwo: [],
      treeThree: []
    }
  },
  computed: {
    ...mapState({
      merchantData: state => state.merchantData,
      brandInfo: state => state.brandInfo,
      isOverseas: state => state.isOverseas
    })
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.searchBrand()
      }
    },
    'ruleForm.brandAnnualTotalConsumption'(newVal, oldVal) {
      /* eslint-disable */
      this.$nextTick(() => {
        this.ruleForm.brandAnnualTotalConsumption = newVal.replace(
          /[^\d|^\.]/g,
          ''
        )
      })
    }
  },
  async mounted() {
    if (this.merchantData && this.merchantData.brand) {
      const data = this.merchantData.brand
      if (data.brandBasic) {
        for (let k in data.brandBasic) {
          if (k in this.ruleForm) this.ruleForm[k] = data.brandBasic[k]
        }
        if (data.brandBasic.reviewDetail) {
          for (let k in data.brandBasic.reviewDetail) {
            if (k in this.reasons && data.brandBasic.reviewDetail[k].reject) this.reasons[k] = data.brandBasic.reviewDetail[k].remark
          }
        }
      }
      if (data.brandQualifications) {
        for (let k in data.brandQualifications) {
          if (k in this.ruleForm) {
            let value = data.brandQualifications[k]
            if (k === 'proxyInfos') {
              const infos = JSON.parse(value)
              infos.forEach(info => {
                info.objectId = info.objectId.split(',')
              })
              this.ruleForm[k] = infos
            }  else if (k === 'thirdPartyPlatformInfos') this.ruleForm[k] = JSON.parse(value)
            else this.ruleForm[k] = value
          }
        }
        if (data.brandQualifications.reviewDetail) {
          for (let k in data.brandQualifications.reviewDetail) {
            if (k in this.reasons && data.brandQualifications.reviewDetail[k].reject) this.reasons[k] = data.brandQualifications.reviewDetail[k].remark
          }
        }
      }
      this.$emit('updateReasonCount', 'brandForm', Object.values(this.reasons).reduce((acc, cur) => acc + (cur ? 1 : 0), 0))
    }
  },
  created() {
    this.assignBrandInfo({ ...this.ruleForm })
  },
  methods: {
    ...mapMutations({
      setContactIndex: 'SET_CONTACT_INDEX',
      assignBrandInfo: 'GET_BRAND_INFO',
      setStepIndex: 'SET_STEP_INDEX'
    }),
    showTree() {
      this.isShowTree = true
    },
    getTrademarkQualificationType() {
      if (this.ruleForm) return this.ruleForm.trademarkQualificationType
      else return '1'
    },
    getTrademarkQualificationLongTermEffective() {
      return this.ruleForm.trademarkQualificationLongTermEffective
    },
    getProxyInfosStartDate(index) {
      if (this.ruleForm && this.ruleForm.proxyInfos[index]) return this.ruleForm.proxyInfos[index].startDate
      else return ''
    },
    handleCheckChange(data, checked, indeterminate) {
      this.treeOne = []
      this.treeTwo = []
      this.treeThree = []
      this.$nextTick(() => {
        this.ruleForm.categoryId = this.$refs.treeForm.getCheckedKeys(true)
        this.categories.forEach(item => {
          item.subCategories &&
            item.subCategories.forEach(p => {
              p.subCategories &&
                p.subCategories.forEach(f => {
                  if (this.ruleForm.categoryId.includes(f.id)) {
                    this.treeThree.push(f.name)
                    this.treeThree = Array.from(new Set(this.treeThree))
                    this.treeTwo = p.name
                    this.treeOne = item.name
                  }
                })
            })
        })
      })
    },
    assignCategoryId() {
      this.isShowTree = false
    },
    handleImageSuccess(key = 'brandLogo') {
      return (res, file, fileList) => {
        const { code } = res
        if (!code) this.ruleForm[key] = res.data.objectId
        else this.$message.error('上传失败，请重试')
        this.$refs.ruleForm.validateField([key])
      }
    },
    proxyImgSuccess(index = 0) {
      return (res, file, fileList) => {
        const { code } = res
        if (!code) {
          if (!this.ruleForm.proxyInfos[index].objectId) this.ruleForm.proxyInfos[index].objectId = []
          this.ruleForm.proxyInfos[index].objectId.push(res.data.objectId)
        } else {
          this.$message.error('上传失败，请重试')
        }
        this.$refs.ruleForm.validateField(`proxyInfos[${index}].objectId`)
      }
    },
    async proxyImageUpload(ctx, index) {
      try {
        const { code, data } = await upload({
          file: ctx.file,
          sourceService: 'youpin_zhaoshang', // 服务名称，默认'test,上线时需要改成youpin_zhaoshang
          bucket: 'private' // 需要私有
        })
        if (!code) {
          if (!this.ruleForm.proxyInfos[index].objectId) this.ruleForm.proxyInfos[index].objectId = []
          this.ruleForm.proxyInfos[index].objectId.push(data.url)
        } else {
          this.$message.error('上传失败，请重试')
        }
        this.$refs.ruleForm.validateField(`proxyInfos[${index}].objectId`)
      } catch (e) {
        this.$message.error(e)
      }
    },
    proxyLevelChange(index) {
      const proxyInfosTotal = this.ruleForm.proxyInfosTotal
      for (let item of proxyInfosTotal) {
        for (let p of this.ruleForm.proxyInfos) {
          if (item.level === p.level) {
            item = { ...p }
          }
        }
      }

      this.ruleForm.proxyInfos = proxyInfosTotal.slice(0, parseInt(index))
    },
    lastAllStep() {
      // 信息注入vuex
      this.assignBrandInfo({
        ...this.ruleForm
      })
      this.setStepIndex(1)
    },
    showFormDialog() {
      this.showBrandsTable = !this.showBrandsTable
    },
    closeFormDialog() {
      this.showBrandsTable = false
    },
    addBrand() {
      this.formEdit = false
      this.showBrandsTable = false
      setTimeout(() => {
        this.$refs.brandName.$el.children[0].focus()
      }, 20)
    },
    handleSizeChange(val) {
      this.currentPage = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    addProof() {
      this.ruleForm.thirdPartyPlatformInfos.push({
        salesChannel: '',
        listoreLinknk: '',
        do: ''
      })
    },
    removeProof(index) {
      const thirdPartyPlatformInfos = this.ruleForm
        .thirdPartyPlatformInfos
      this.ruleForm.thirdPartyPlatformInfos = thirdPartyPlatformInfos.filter(
        (item, idx) => idx !== index
      )
    },
    chooseBrand(info) {
      this.ruleForm = { ...this.ruleForm, ...info }

      setTimeout(() => {
        this.$refs.ruleForm.validateField([
          'brandName',
          'brandEnglishName',
          'brandLogo',
          'brandIntroduction',
          'brandSlogan'
        ])
      }, 20)
      this.formEdit = true
      this.showBrandsTable = false
    },
    async getCategoryInfo() {
      try {
        const info = await getCategory()
        let parentId = 0
        let filteArr = []
        const categoryId = this.ruleForm.categoryId

        const setDisable = arr => {
          arr.forEach(item => {
            item.disabled = true
            item.subCategories &&
              item.subCategories.forEach(e => {
                e.disabled = true
                e.subCategories &&
                  e.subCategories.forEach(f => {
                    categoryId.length &&
                      categoryId.forEach(p => {
                        if (parseInt(p) === f.id) {
                          parentId = f.parentId
                        }
                      })
                  })
                if (e.id !== parentId) {
                  e.subCategories &&
                    e.subCategories.forEach(g => {
                      g.disabled = true
                    })
                }
              })
          })
          arr.forEach(g => {
            g.subCategories.forEach(h => {
              h.subCategories.forEach(m => {
                if (m.disabled === undefined) {
                  filteArr.push(g)
                }
              })
            })
          })
          return Array.from(new Set(filteArr))
        }
        const { code, data } = info
        if (!code) {
          const { categories } = data
          this.categories = setDisable(categories)
        } else {
          this.$message.error('服务器错误')
        }
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    async searchBrand() {
      if (!this.tableForm.keyword) return

      this.brandListLoading = true
      try {
        const info = await getBrand({
          keyword: this.tableForm.keyword,
          pageNum: this.currentPage
        })
        if (!info.code) {
          this.brandListLoading = false
          this.brandList = info.data.content
          this.paginations.total = info.data.totalElements
          this.currentPage = info.data.pageNum
        } else {
          this.brandListLoading = false
          this.$message.error(info.msg || '未知错误，请重试')
        }
      } catch (e) {
        this.brandListLoading = false
      }
    },

    submitForm(formName, jump = true) {
      const proxyInfos = deepCopy(this.ruleForm.proxyInfos)
      if (proxyInfos && Array.isArray(proxyInfos)) {
        proxyInfos.forEach(info => {
          if (info && info.objectId && Array.isArray(info.objectId)) {
            info.objectId = info.objectId.join(',')
          }
        })
      }
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(async valid => {
          if (!valid) {
            reject()
            return false
          }
          const params = {
            brandBasic: {
              brandId: this.ruleForm.brandId,
              brandName: this.ruleForm.brandName,
              brandEnglishName: this.ruleForm.brandEnglishName,
              brandLogo: this.ruleForm.brandLogo,
              brandSlogan: this.ruleForm.brandSlogan,
              brandIntroduction: this.ruleForm.brandIntroduction
            },
            brandQualifications: {
              brandType: this.ruleForm.brandType,
              managementType: this.ruleForm.managementType,
              proxyLevel: this.ruleForm.proxyLevel,
              proxyInfos: JSON.stringify(proxyInfos),
              trademarkQualificationType: this.ruleForm.trademarkQualificationType,
              trademarkQualificationObjectId: this.ruleForm.trademarkQualificationObjectId,
              trademarkQualificationRegistrant: this.ruleForm.trademarkQualificationRegistrant,
              trademarkQualificationCategory: this.ruleForm.trademarkQualificationCategory,
              trademarkQualificationNumber: this.ruleForm.trademarkQualificationNumber,
              trademarkQualificationStartDate: this.ruleForm.trademarkQualificationStartDate,
              trademarkQualificationEndDate: this.ruleForm.trademarkQualificationEndDate,
              trademarkQualificationLongTermEffective: this.ruleForm.trademarkQualificationLongTermEffective,
              thirdPartyPlatformInfos: JSON.stringify(this.ruleForm.thirdPartyPlatformInfos),
              brandAnnualTotalConsumption: this.ruleForm.brandAnnualTotalConsumption
            }
          }
          this.saveBtnDisabled = true
          const result = await postBrand(params)
          this.saveBtnDisabled = false
          if (!result.code) {
            if (jump) {
              this.setStepIndex(3)
              window.location.reload()
            }
            resolve()
          } else {
            this.$message.error(result.msg || '提交失败')
            reject()
          }
        })
      })
    },
    /**
     * @name removeImage
     * @description 删除图片按钮
     */
    removeImage(ruleForm, key) {
      ruleForm[key] = null
    },
    /**
     * @name removeProxyImage
     * @description 删除代理图片
     */
    removeProxyImage(item, idx) {
      item.splice(idx, 1)
    },
    /**
     * @name managementTypeChange
     * @description 经营类型变化
     */
    managementTypeChange(index) {
      // 代理等级后端数据异常时重置
      if (index === '2' && !['1', '2', '3', '4', '5'].includes(this.ruleForm.proxyLevel)) {
        this.ruleForm.proxyLevel = '1'
        this.proxyLevelChange(this.ruleForm.proxyLevel)
      }
    }
  }
}
</script>

<style lang="less">
.brand-form-wrapper {
  .el-dialog .el-form {
    width: 100% !important;
    .el-input {
      width: 180px !important;
    }
  }
  .el-col-6 {
    width: 160px;
  }
  .tree {
    .el-tree {
      width: 377px;
    }
    .left100 {
      color: #606266;
    }
  }
  .table-proof {
    td {
      &:last-child {
        .cell {
          margin-top: -10px;
        }
      }
    }
    .cell {
      padding: 0;

      .el-button {
        padding: 7px 10px;
        min-width: 50px;
      }

      .auto-height {
        height: 40px;
      }
    }
    .el-form-item {
      margin: 0;
    }

    .el-table__empty-block {
      display: none;
    }
  }
  .el-dialog {
    .el-pagination {
      .el-input {
        width: 50px !important;
      }
    }
    .row-footer {
      display: block;

      .text {
        text-align: left;
        margin-top: -10px;
        font-size: 13px;
      }
    }
    .el-col {
      text-align: left;
      padding: 0;
    }
    .el-col-6 {
      width: 160px;
    }
  }
  .proof-item .table-proof {
    .el-input,
    .el-form-item__error {
      width: 95% !important;
    }
  }
  .brand-form {
    .age-form {
      line-height: 28px;
      .el-form-item__content {
        display: flex;
        align-items: center;

        .form-text {
          margin: 0 10px 18px;
          letter-spacing: 5px;
        }
      }
      .el-input {
        width: 130px;
      }
    }
  }

  th {
    height: 26px;
    line-height: 26px;
    border-right: none;
    padding: 0;
    color: #4a4a4a;
    font-weight: 400;
    background: #f9f9f9;
  }

  td {
    height: 49px;
    line-height: 49px;
    color: #4a4a4a;
    padding: 0;
  }

  .cell {
    padding-left: 20px !important;
  }

  .btn-warning {
    background: #FFB35E;
    color: #fff;
    border: none;
    margin-top: 9px;
    width: 26px;
    height: 26px;
    min-width: 0 !important;
    padding: 0 !important;
  }

  .el-table {
    .el-form-item__error {
      display: none;
    }

    .el-form-item--mini {
      display: flex;
      align-items: center;
    }
  }

  .reason {
    font-size: 13px;
    line-height: 16px;
    color: #E00C0C;
    display: inline-block;
    padding-left: 20px;

    &.block {
      display: block;
      margin-top: 10px;
      margin-left: -20px;
    }

    &.uploader-reason {
      position: absolute;
      top: 7px;
      left: 100px;
    }
  }

  .multiple-uploader {
    margin-top: 10px;

    .flex-box {
      display: flex;
    }

    .upload-box {
      border: 1px dashed #cecece !important;
      background: #F9F9F9;
      width: 90px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;

      .avatar-uploader-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px !important;
        font-weight: 700;
        color: #fff !important;
        width: 24px !important;
        height: 24px !important;
        background: #e2e2e2;
        border-radius: 24px;
      }
    }

    .items {
      display: flex;

      .img-item {
        margin-right: 10px;
        position: relative;

        & > img {
          border-radius: 4px;
          border: none;
          width: 90px !important;
          height: 90px;
          object-fit: cover;
          cursor: default;
        }

        .btn-close {
          position: absolute;
          right: -10px;
          top: -10px;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }

  .header {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 30px;
    color: #333;
    border-bottom: 1px solid #DEDDDD;

    .title {
      margin-top: 20px;
      margin-bottom: 5px;
      margin-left: 10px;
    }
  }
}
</style>
